import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { VehicleTransportService } from 'src/app/vehicle-transport/vehicle-transport.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { from } from 'rxjs';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-vehicle-transport-table',
  templateUrl: './vehicle-transport-table.component.html',
  styleUrls: ['./vehicle-transport-table.component.scss']
})

export class VehicleTransportTableComponent implements OnInit {
  displayedColumns: string[] = ['id','transport_name', 'contact_person', 'mobile', 'addresss', 'edit'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public vehicleTransportService: VehicleTransportService, private global: GlobalService) {
    this.global.set_master_page_title = 'Transport Name';
    this.getVehicleTransports();
    this.vehicleTransportService.downloadVehicleTransport.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getVehicleTransports();
      }
    });
  }

  showVehicleTransportRegister() {
    this.vehicleTransportService.is_display_vehile_transport_register_component = true;
  }

  hideVehicleTransportRegister() {
    this.vehicleTransportService.is_display_vehile_transport_register_component = false;
  }

  registerVehicleTransport() {
    this.showVehicleTransportRegister();
    console.log('register zone');
    this.vehicleTransportService.vehicleTransportUpdate.emit(null);
    this.vehicleTransportService.set_vehicle_transport_data = null;
  }

  editVehicleTransport(vehicle_transport) {
    this.showVehicleTransportRegister();
    console.log(vehicle_transport);
    this.vehicleTransportService.vehicleTransportUpdate.emit(vehicle_transport);
    this.vehicleTransportService.set_vehicle_transport_data = vehicle_transport;
  }

  getVehicleTransports() {
    this.http.getVehicleTransports().subscribe((data: VehicleTransport[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<VehicleTransport>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
  }

}
export interface VehicleTransport {
  id: number;
  contact_person: string;
  mobile: number;
  alternate_mobile: number;
  address: string;
}
